import {DatePipe} from '@angular/common';
import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ServiceTypeEnum} from 'src/app/shared/enums';
import {Direction} from 'src/app/shared/enums/direction.enum';
import {PricingResponse} from 'src/app/shared/models';
import {Price} from 'src/app/shared/models/price.model';
import {OrderService} from 'src/app/shared/services';
import {ConfirmCancelModalComponent} from '../../../shared/components/confirm-cancel-modal/confirm-cancel-modal.component';
import {ShippingService} from '../shipping.service';

@Component({
   selector: 'app-shipping-options',
   templateUrl: './shipping-options.component.html',
   styleUrls: ['./shipping-options.component.scss'],
})
export class ShippingOptionsComponent implements OnInit {
   @Output() optionEmitter = new EventEmitter();
   options: Array<PricingResponse>;
   normalizedOptions: Array<any> = [];
   filterNormalizedOptions: Array<any> = [];
   errorCarriers: string = '';

   expanded = false;
   serviceTypeEnum = ServiceTypeEnum;
   editModeOn: boolean;
   option: any;
   confirmedOption: any;
   translatePath = 'public.shipping-options.';
   private readonly sessionStorageOptionKey = 'mdeliverysavedorderoption';
   sessionSavedOption: any;
   params: ParamMap;
   directionEnum = Direction;
   returUrl = this.route.snapshot.queryParams.returUrl;
   orderId = this.route.snapshot.queryParams.orderId;
   directions: any[] = [];
   internationalShipping = false;

   constructor(
      private orderService: OrderService,
      private datePipe: DatePipe,
      private translateService: TranslateService,
      private route: ActivatedRoute,
      private sanitization: DomSanitizer,
      private modalService: NgbModal,
      private shippingService: ShippingService,
      private cdr: ChangeDetectorRef
   ) {}
   ngOnInit(): void {
      this.params = this.route.snapshot.queryParamMap;
      this.handleShippingType();
   }

   normalizeString(value: string): string {
      value = value.toLowerCase().trim();
      value = value.replace('ă', 'a');
      value = value.replace('â', 'a');
      value = value.replace('î', 'i');
      value = value.replace('ț', 't');
      value = value.replace('ţ', 't');
      value = value.replace('ș', 's');
      value = value.replace('ş', 's');
      return value;
   }

   getOptions(config: any) {
      console.log(config);
      if (config.isLocal === false) {
         // @ts-ignore
         config.internationalRecipientAddress = config.recipientAddress;
         config.recipientAddress = null;
      }
      config.orderId = this.orderId;
      return this.orderService.getCarrierOptions(config);
   }

   getErrorCarriers(item: any) {
      if (!item?.succeeded) {
         if (this.errorCarriers === '') {
            this.errorCarriers = item?.carrier?.carrierName;
         } else {
            this.errorCarriers = this.errorCarriers + ', ' + item?.carrier?.carrierName;
         }
      }
   }

   applyFilter(event: any): void {
      this.filterNormalizedOptions = this.normalizedOptions.filter((x) =>
         x.carrier.carrierName.toLowerCase().includes(this.normalizeString(event.target.value))
      );
   }

   createOptionsList(): void {
      this.normalizedOptions = [];
      this.options.forEach((item) =>
         item.pricing.forEach((price) => this.normalizedOptions.push({...price, carrier: item.carrier}))
      );
      this.filterNormalizedOptions = this.normalizedOptions;
      this.filterNormalizedOptions.forEach((item) => {
         item.direction === this.directionEnum.AddressToAddress ||
         item.direction === this.directionEnum[this.directionEnum.AddressToAddress]
            ? this.directions.push(item)
            : null;
      });
      this.filterNormalizedOptions = this.filterNormalizedOptions.sort((itemA: Price, itemB: Price) => {
         return itemA.cost - itemB.cost;
      });
   }

   inputChecked(item: Price): any {
      return this.confirmedOption && item.no == this.confirmedOption.no;
   }

   createLogoBase64Url(logoBase64: string): SafeUrl {
      return this.sanitization.bypassSecurityTrustUrl(`${logoBase64}`);
   }

   gotToUrl(url: string) {
      location.replace(url);
   }

   getCarrierName() {
      return this.options.find((o) => o.pricing.find((p) => p.no === this.confirmedOption.no))?.carrier.carrierName;
   }

   getCarrierId() {
      return this.options.find((o) => o.pricing.find((p) => p.no === this.confirmedOption.no))?.carrier.carrierId;
   }

   sort(event: any) {
      switch (event.target.value) {
         case 'deliveryCostLH':
            this.filterNormalizedOptions.sort((itemA: Price, itemB: Price) => {
               return itemA.cost - itemB.cost;
            });
            break;
         case 'deliveryCostHL':
            this.filterNormalizedOptions.sort((itemA: Price, itemB: Price) => {
               return itemB.cost - itemA.cost;
            });
            break;
         case 'companyAZ':
            this.filterNormalizedOptions.sort((itemA: any, itemB: any) => {
               return itemA.carrier.carrierName >= itemB.carrier.carrierName ? 1 : -1;
            });
            break;
         case 'companyZA':
            this.filterNormalizedOptions.sort((itemA: any, itemB: any) => {
               return itemA.carrier.carrierName <= itemB.carrier.carrierName ? 1 : -1;
            });
            break;
         case 'deliverytimeLH':
            this.filterNormalizedOptions.sort((itemA: Price, itemB: Price) => {
               return itemA.estimatedOnEnd >= itemB.estimatedOnEnd ? 1 : -1;
            });
            break;
         case 'deliverytimeHL':
            this.filterNormalizedOptions.sort((itemA: Price, itemB: Price) => {
               return itemA.estimatedOnEnd <= itemB.estimatedOnEnd ? 1 : -1;
            });
            break;
         default:
            this.filterNormalizedOptions.sort((itemA: Price, itemB: Price) => {
               return itemA.cost - itemB.cost;
            });
            break;
      }
   }

   getAddressText(item: Price) {
      let address = item.addressOfDepartment;
      return address
         ? `
    ${address.street.value ? address.street.value + ', ' : ''}
    ${address.block ? address.block + ', ' : ''}
    ${address.apartment ? address.apartment + ', ' : ''}
    ${address.zipCode ? 'MD-' + address.zipCode + ', ' : ''}
    ${address.city.value ? address.city.value + ', ' : ''}
    ${address.region.value ? address.region.value + ', ' : ''}
    ${address.provinceCode ? address.provinceCode + ', ' : ''}
    ${address.country.value ? address.country.value : ''}
    `
         : '';
   }

   selectedChanged(item: Price) {
      this.option = item;
   }

   confirmOption() {
      this.confirmedOption = this.option;
      this.saveOptionToLocal(this.confirmedOption);
      this.optionEmitter.emit(this.confirmedOption);
   }

   setEditModeState(state: boolean) {
      this.editModeOn = state;
   }

   onEditModeStateChange(state: boolean) {
      this.editModeOn = state;
      this.expanded = state;
      console.log(state);
      this.cdr.detectChanges();
   }

   saveOptionToLocal(confirmedOption: Price) {
      const orderId = this.params.has('orderId') ? this.params.get('orderId') : null;
      const serviceId = this.params.has('serviceId') ? this.params.get('serviceId') : null;
      sessionStorage.setItem(this.sessionStorageOptionKey, JSON.stringify({confirmedOption, orderId, serviceId}));
   }

   cancel(): void {
      const modalRef = this.modalService.open(ConfirmCancelModalComponent);
      modalRef.result.then((response: string) => {
         if (response === 'confirmed') {
            location.replace(`${this.returUrl}?orderId=${this.orderId}`);
         } else {
            return;
         }
      });
   }

   handleShippingType(): void {
      this.shippingService.handleInternationalShipping.subscribe((res) => {
         typeof res === 'boolean' ? (this.internationalShipping = res) : (this.internationalShipping = false);
      });
   }
}
